module.exports = __webpack_public_path__ + "img/SP-Profi_Overview-Spare_1.e9833409.jpg";